module.exports = __webpack_public_path__ + "static/media/icon-create-account-active.441fd5fd.svg";